<template>
	<div>
		Configuraciones
	</div>
</template>

<script>
	export default {
		name: 'settings',
	};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sales/settings.vue